export const VIDEO_STYLE_SCHEMA = {
  chapterLayout: { default: 'list' },
  chapterAccent: { default: '' },
  chapterTextStyles: { style: 'theme' },
};
